export const HTTP_UNPROCESSABLE_ENTITY = 422
export const HTTP_NOT_FOUND = 404
export const HTTP_FORBIDDEN = 403
export const HTTP_OK = 200
export const HTTP_NO_CONTENT = 204

/**
 * Fetch async
 * 
 * @param {string} url
 * @param {Object} params
 * @return {Promise<Object>} Return the request result or throw ApiError
 */
export async function jsonFetch(url, params = {}) {
    params = {
        credentials: "same-origin",
        ...params,
    };

    const response = await fetch(url, params);
    if (response.status === 204) {
        return null;
    }
    const data = await response.json();
    return data;
}